import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M2.963 8.114c-.953.953-.502 2.582.806 2.909a7.124 7.124 0 0 1 4.921 4.354l1.514 3.936a1.75 1.75 0 0 0 2.871.61l3.331-3.332 5.127 5.127a.75.75 0 0 0 1.06-1.061l-5.126-5.127 3.331-3.331a1.75 1.75 0 0 0-.609-2.87l-3.936-1.515a7.124 7.124 0 0 1-4.354-4.921c-.327-1.308-1.956-1.76-2.91-.806L2.964 8.114Zm7.088-4.966a.234.234 0 0 1 .393.109 8.624 8.624 0 0 0 5.27 5.957l3.937 1.514a.25.25 0 0 1 .087.41l-7.724 7.724a.25.25 0 0 1-.41-.087l-1.514-3.937a8.624 8.624 0 0 0-5.957-5.27.234.234 0 0 1-.11-.393l6.028-6.027Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n
];
function c(r, d) {
  return e(), l("svg", o, [...a]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
